import React, { Component } from 'react';
import { Typography, Grid } from '@material-ui/core';
import { connect } from 'react-redux';
import './index.scss';

import { CarCard, AUTSlider } from '../../../../components';

const PrevArrow = ({ className, style, onClick }) => (
  <i
    className={`material-icons ${className}`}
    onClick={onClick}
    onKeyDown={onClick}
    style={{
      ...style,
      zIndex: 1,
      color: 'white',
      fontSize: '48px',
      textShadow: '1px 1px 10px #000'
    }}
    role="button"
    tabIndex="0"
  >
    keyboard_arrow_left
  </i>
);

const NextArrow = ({ className, style, onClick }) => (
  <i
    className={`material-icons ${className}`}
    onClick={onClick}
    onKeyDown={onClick}
    style={{
      ...style,
      zIndex: 1,
      color: 'white',
      fontSize: '48px',
      textShadow: '1px 1px 10px #000'
    }}
    role="button"
    tabIndex="0"
  >
    keyboard_arrow_right
  </i>
);

class RecentlyAddedSlider extends Component {
  slideSettings = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false
        }
      }
    ]
  };

  nextSlide = () => {
    this.slider.slickNext();
  };

  prevSlide = () => {
    this.slider.slickPrev();
  };

  render() {
    const { dispatch, items } = this.props;
    return (
      <div className="recently-added">
        <Grid container justify="space-between">
          <Typography gutterBottom variant="display1">
            Recently Added
          </Typography>
          <Grid item>
            <i
              className="material-icons prev"
              onClick={this.prevSlide}
              onKeyPress={this.prevSlide}
              role="button"
              tabIndex="0"
            >
              arrow_back
            </i>
            <i
              className="material-icons next"
              onClick={this.nextSlide}
              onKeyPress={this.nextSlide}
              role="button"
              tabIndex="0"
            >
              arrow_forward
            </i>
          </Grid>
        </Grid>
        <AUTSlider
          className="recently-slider"
          sliderRef={c => (this.slider = c)} // eslint-disable-line
          settings={this.slideSettings}
        >
          {items.map((vehicle) => (
            <CarCard key={vehicle.id} vehicle={vehicle} dispatch={dispatch} />
          ))}
        </AUTSlider>
      </div>
    );
  }
}

export default connect()(RecentlyAddedSlider);


